import { SectionDivider, SidebarModal } from '@domain-group/suit-theme'

import ServiceIcon from '@components/Icons/ServiceIcon'
import SquareIconWithBackground from '@components/SquareIconWithBackground'

import type { UseNewOrderPayload } from '@modals/NewOrderModal'

import Services from './components/Services'

interface DefaultStateProps {
  newOrderPayload: UseNewOrderPayload,
}

const DefaultState = (props: DefaultStateProps) => {
  const {
    newOrderPayload: {
      callbacks: {
        selectProductSearchResult,
        selectServiceId,
      },
      filteredServices,
      isDefaultQuoteItem,
      selectedAgency,
      selectedCampaign,
    },
  } = props

  return (
    <SidebarModal.Content hasFooter={false}>
      {!isDefaultQuoteItem && (
        <SidebarModal.Button
          boxProps={{
            border: 0,
            marginTop: 'medium',
            paddingX: 0,
            paddingY: 0,
          }}
          iconLeft={(
            <SquareIconWithBackground backgroundColor="#F5F1FC">
              <ServiceIcon fillColor="#B69DEB" height={28} serviceKey="bundles" width={28} />
            </SquareIconWithBackground>
          )}
          onClick={() => selectServiceId('bundles')}
          showAngleIcon
          subtitle="Select multi-provider packages"
          title="Bundles"
        />
      )}

      {!isDefaultQuoteItem && (
        <SidebarModal.Button
          boxProps={{
            border: 0,
            marginTop: 'medium',
            paddingX: 0,
            paddingY: 0,
          }}
          iconLeft={(
            <SquareIconWithBackground backgroundColor="#EBEFF5">
              <ServiceIcon fillColor="#8C9FBF" height={28} serviceKey="favourites" width={28} />
            </SquareIconWithBackground>
          )}
          onClick={() => selectServiceId('favourites')}
          showAngleIcon
          subtitle="Select from your favourite orders"
          title="Favourites"
        />
      )}

      <SidebarModal.Button
        boxProps={{
          border: 0,
          marginTop: 'medium',
          paddingX: 0,
          paddingY: 0,
        }}
        iconLeft={(
          <SquareIconWithBackground backgroundColor="#F7F6F2">
            <ServiceIcon fillColor="#D0C6B1" height={28} serviceKey="packages" width={28} />
          </SquareIconWithBackground>
        )}
        onClick={() => selectServiceId('packages')}
        showAngleIcon
        subtitle="Select from provider packages"
        title="Packages"
      />

      <SectionDivider boxProps={{ marginTop: 'medium' }}>
        Browse Products
      </SectionDivider>

      <Services
        agencyId={selectedCampaign.agency_id || selectedAgency.id}
        callbacks={{ selectProductSearchResult, selectServiceId }}
        services={filteredServices}
      />
    </SidebarModal.Content>
  )
}

export default DefaultState
